export * from './delete-foto-kategorie.component';
export * from './delete-foto-kategorie.component.module';
